import React from 'react';
import { Modal } from '../../../../../base/components/Modal';
import { __t } from '../../../../../base/utils/t';
import { ReactComponent as Icon } from '../../assets/img/quick-apply-modal-icon.svg';

import './styles.scss';

interface Props {
    visible: boolean;
    visibilityHandler: () => void;
}

export const QuickApplyExplanationModal = ({ visible, visibilityHandler }: Props) => {
    return (
        <Modal
            visible={visible}
            className='quick-apply-explanation-modal'
            containerClassName='quick-apply-explanation-modal__container'
            visibilityHandler={visibilityHandler}
        >
            <h3 className='quick-apply-explanation-modal__title'>{__t('Что означает «Отклик без анкеты»?')}</h3>
            <p className='quick-apply-explanation-modal__text'>
                {__t(
                    'Обычно, чтобы откликнуться на вакансию, работники должны зарегистрироваться на нашем сайте и заполнить анкету с подробной информацией о себе. Для вакансий с функцией "Отклик без анкеты" не требуется регистрация, работнику достаточно заполнить минимум информации:',
                )}
            </p>
            <div className='quick-apply-explanation-modal__wrap'>
                <Icon className='quick-apply-explanation-modal__icon' />
                <ul className='quick-apply-explanation-modal__list'>
                    <li className='quick-apply-explanation-modal__list-item'>{__t('Контактный номер телефона')}</li>
                    <li className='quick-apply-explanation-modal__list-item'>{__t('Имя')}</li>
                    <li className='quick-apply-explanation-modal__list-item'>{__t('Возраст')}</li>
                    <li className='quick-apply-explanation-modal__list-item'>{__t('Гражданство')}</li>
                    <li className='quick-apply-explanation-modal__list-item'>{__t('Текущее местонахождение')}</li>
                    <li className='quick-apply-explanation-modal__list-item'>{__t('Короткую информацию о себе')}</li>
                </ul>
            </div>
            <h3 className='quick-apply-explanation-modal__title'>{__t('Кому полезна функция «Отклик без анкеты»?')}</h3>
            <p className='quick-apply-explanation-modal__text'>
                {__t(
                    'Данная функция подойдет для вакансий без высоких требований к работнику. Вы сможете получить максимальное количество контактных данных работников, а все нюансы выяснить на прямую с кандидатами.',
                )}
            </p>
        </Modal>
    );
};
